export default function LoadingIcon() {
  return <img src={process.env.PUBLIC_URL + "/images/Loading-Icon.gif"} alt="Loading..." />;
}
